import { useEffect, useState } from "@wordpress/element";
import { MAP_CONTROLS } from "../../constant/map-control";
import { IControl } from "@/components/map-container/types/map-type";

import MapIconButton from "@/components/map-container/components/map-icon-button/MapIconButton";

import "./style.scss";

type MapControlWarningsProps = {
	setSelectedFilter: (value?: string) => void;
};

export const MapControlWarnings = ({
	setSelectedFilter,
}: MapControlWarningsProps) => {
	const [controls, setControls] = useState<IControl[]>(MAP_CONTROLS);

	const handleToggle = (text: string) => {
		setControls((prev) => {
			const clicked = prev.find((c) => c.text === text);
			if (!clicked) {
				return prev;
			}

			const isSingleActive = prev.filter((c) => c.isActive).length === 1;

			if (isSingleActive && clicked.isActive) {
				return prev.map((c) => ({ ...c, isActive: true }));
			}

			return prev.map((c) => ({
				...c,
				isActive: c.text === text,
			}));
		});
	};

	const allActive = controls.every((item) => item.isActive === true);

	useEffect(() => {
		if (controls.every((c) => c.isActive)) {
			setSelectedFilter(undefined);
			return;
		}

		const activeControl = controls.find((c) => c.isActive);
		setSelectedFilter(activeControl?.value);
	}, [controls, setSelectedFilter]);

	return (
		<div className="weather-control-container">
			{controls.map((control) => (
				<MapIconButton
					key={control.text}
					data={control}
					isActive={allActive ? false : control.isActive}
					handleClick={handleToggle}
				/>
			))}
		</div>
	);
};

export default MapControlWarnings;
